define([], function () {
    'use strict';

    return function measureGrid(gridContainer, {compProp, compData, compTheme}) {
        const MAX_ROWS = 200;

        const PaginationType = {
            PAGES: 'pagination',
            SCROLL: 'virtual',
            NONE: 'normal'
        };

        const HeightLayout = {
            MANUAL: 'manual',
            AUTOMATIC: 'auto'
        };

        const HEADER_BORDER_WIDTH = 'headerDivider_w';
        const ROW_BORDER_WIDTH = 'rowDivider_w';

        function getStyleItem(itemName) {
            return compTheme.style.properties[itemName] || '';
        }

        function getNumberOfRows() {
            const pagination = compProp.pagination;

            return compData.numberOfDisplayedRows ||
                   (pagination && pagination.type === PaginationType.PAGES ?
                       pagination.rowsPerPage :
                       compData.rows.length);
        }

        // These two assignments have no visible layout effect (as far as I can see)
        const width = gridContainer.offsetWidth;
        let height = gridContainer.offsetHeight;

        const rowHeight = compProp.rowHeight + Number(getStyleItem(ROW_BORDER_WIDTH));
        const numberOfRows = Math.min(getNumberOfRows(), MAX_ROWS);
        const headerHeight = compProp.showHeader ?
            compProp.headerHeight + Number(getStyleItem(compTheme, HEADER_BORDER_WIDTH)) : 0;
        const borderWidth = Number(compTheme.style.properties.containerBrw) || 0;
        const calculatedGridHeight = headerHeight + numberOfRows * rowHeight + 2 * borderWidth; // eslint-disable-line no-mixed-operators
        const isHeightLayoutAutomatic = compProp.heightLayout === HeightLayout.AUTOMATIC;

        // This entire block has no visible layout effect (as far as I can see)
        const gridBodyContainer = gridContainer.getElementsByClassName('ag-bl-center ag-bl-full-height-center');
        if (gridBodyContainer.length) {
            const gridBody = gridContainer.getElementsByClassName('ag-body');
            const clientHeight = isHeightLayoutAutomatic ? calculatedGridHeight : gridBodyContainer[0].clientHeight;
            gridBody[0].style.height = `${clientHeight - 2 * borderWidth - headerHeight}px`; // eslint-disable-line no-mixed-operators
        }

        if (calculatedGridHeight && isHeightLayoutAutomatic) {
            height = calculatedGridHeight;
        }

        return [{node: gridContainer, type: 'css', changes: {width, height}}];
    };
});
